export * from './imoveis-documentos-selecionar-tipo/imoveis-documentos-selecionar-tipo.module';
export * from './imoveis-documentos/imoveis-documentos.module';
export * from './imoveis-editar/imoveis-editar.module';
export * from './imoveis-endereco/imoveis-endereco.module';
export * from './imoveis-ficha/imoveis-ficha.module';
export * from './imoveis-informacoes-adicionais/imoveis-informacoes-adicionais.module';
